/*
 * Class names, joined. Components take an optional `className` so a caller can place them; this
 * keeps the joining out of every component (`cx("tb-button", variant, className)`).
 */

export function cx(...parts: (string | false | null | undefined)[]): string {
	return parts.filter(Boolean).join(" ")
}
